import {DashboardUserDeletedReadingsTable} from './DashboardUserDeletedReadingsTable';

export default DashboardUserDeletedReadingsTable;
